import { ArrowForward } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import { getEligibleApplications } from "apis/controllers/disbursements";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { createDisbursement } from "src/apis/controllers/disbursements";
import { useLoading } from "src/hooks/useLoading";
import Dropdown from "src/qubCommon/Inputs/Dropdown";

const NewPaymentApplicationPanel = (props) => {
  const form = useForm();
  const { visible } = props;
  const [selected, setSelected] = useState("");
  const [disbursementTypes, setDisbursementTypes] = useState([]);
  const [eligibleApplications, setEligibleApplications] = useState([]);
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  // const handleChange = async (id) => {
  //   setLoading(true);
  //   form.reset({});
  //   setSelected(selected === id ? null : id);
  //   try {
  //     const res = { data: [{ id: 1, name: 2 }] }; // getDisbursementTypes(id)

  //     setDisbursements(res?.data);
  //   } catch (e) {
  //     setLoading(false);
  //   }
  //   setLoading(false);
  // };

  const fetchEligibleApplications = async () => {
    setLoading(true);
    try {
      const res = await getEligibleApplications(); //getDisbursementTypes()
      setLoading(false);
      console.log(res?.data);
      setEligibleApplications(res?.data);
    } catch {
      setLoading(false);
    }
  };
  // const handleAdditionalInstitutes = async (defaultSelectedIds = []) => {
  //   form.setValue("selid", null);
  //   const selectedIds = form
  //     ?.getValues("ids")
  //     ?.map((selection) => selection?.id);
  //   setLoading(true);
  //   try {
  //     const res = await getAdditionalInstitutes(
  //       defaultSelectedIds?.length > 0 ? defaultSelectedIds : selectedIds
  //     );
  //     setAdditionalInstitutes(res?.data);
  //   } catch {
  //     setLoading(false);
  //   }
  //   setLoading(false);
  // };

  useEffect(() => {
    fetchEligibleApplications();
  }, []);

  const handleCreateDisbursement = async (data) => {
    try {
      setLoading(true);
      const res = await createDisbursement(data);
      console.log(res);
      if (res?.status === "success")
        navigate(`/disbursement-application/${res?.data}`);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  return (
    <div
      className={visible ? "card with-slide open" : " card with-slide closed"}
    >
      <div className="card-header">
        <h4>
          <b>Λεπτομέρειες Αίτησης Εκταμίευσης</b>
        </h4>
      </div>
      <div className="card-body">
        <Grid container>
          <FormProvider {...form}>
            {/* <Grid item xs={12} md={4}>
              <Stack direction="column">
                <Typography>Τύπος Αίτησης:</Typography>
                <FormGroup>
                  {disbursementTypes.map((item) => (
                    <FormControlLabel
                      key={item.id}
                      control={
                        <Checkbox
                          checked={selected === item.id}
                          onChange={() => handleChange(item.id)}
                          name={item.display}
                          disabled={!item.isActive}
                        />
                      }
                      label={item.display}
                    />
                  ))}
                </FormGroup>
              </Stack>
            </Grid> */}
            <Grid container item xs={12} md={12} spacing={2}>
              <Grid item xs={12} md={6}>
                <Dropdown
                  name="id"
                  labelName="name"
                  valueName="id"
                  label="Επιλογή Αίτησης"
                  options={eligibleApplications}
                />
              </Grid>
              {form?.watch("id") && (
                <Grid item xs={12} md={6}>
                  <Button
                    variant="contained"
                    color="secondary"
                    endIcon={<ArrowForward />}
                    sx={{ color: "#fefefe", marginTop: "28px" }}
                    onClick={form?.handleSubmit(handleCreateDisbursement)}
                  >
                    Συνέχεια
                  </Button>
                </Grid>
              )}
            </Grid>
          </FormProvider>
        </Grid>
      </div>
    </div>
  );
};

export default NewPaymentApplicationPanel;
